import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import {
  removeSnackbar,
  closeSnackbar as closeSnackbarFn,
} from '@app/store/snackbar';
import SnackBarCloseBtn from '@app/components/Snackbar/closeBtn';

const normalizeNotifierMessage = message => {
  if (!Array.isArray(message)) {
    return message;
  }
  const strings = message
    .flat(Infinity)
    .filter(part => typeof part === 'string' && part !== '');
  if (strings.length > 0) {
    return strings.join('\n');
  }
  return message;
};

const Notifier = () => {
  const dispatch = useDispatch();
  const displayedRef = React.useRef([]);

  const notifications = useSelector(store => {
    return store.snackbar.notifications;
  });

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const storeDisplayed = id => {
    displayedRef.current = [...displayedRef.current, id];
  };
  const removeDisplayed = id => {
    displayedRef.current = displayedRef.current.filter(key => id !== key);
  };

  React.useEffect(() => {
    notifications.forEach(notification => {
      const { key, message, options = {}, dismissed = false } = notification;
      if (dismissed) {
        closeSnackbar(key);
        return;
      }

      if (displayedRef.current.includes(key)) return;

      const resolvedVariant = options.variant;

      enqueueSnackbar({
        ...options,
        key,
        message: normalizeNotifierMessage(message),
        ...(resolvedVariant ? { variant: resolvedVariant } : {}),
        onClose: (event, reason, myKey) => {
          if (options.onClose) {
            options.onClose(event, reason, myKey);
          }
        },
        onExited: (event, myKey) => {
          dispatch(removeSnackbar(myKey));
          removeDisplayed(myKey);
        },
      });

      storeDisplayed(key);
    });
  }, [notifications, closeSnackbar, enqueueSnackbar, dispatch]);

  return null;
};

export const alertOptions = ({ dispatch, variant }) => ({
  variant,
  action: key => (
    <SnackBarCloseBtn onClose={() => dispatch(closeSnackbarFn(key))} />
  ),
});

export default Notifier;
